/**
 * @generated SignedSource<<82f7913184f2c892761a914b67fa0759>>
 * @relayHash 701de8d25c0615cd65d074a2d0d26386
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9e4874aa6f1795a40140739a4ef2d22670502e0aa0add7ff9834458df2767c17

import type { ConcreteRequest } from 'relay-runtime';
export type useSmartFolderAncestorSyncQuery$variables = {
  contentId: string;
};
export type useSmartFolderAncestorSyncQuery$data = {
  readonly ptpage: {
    readonly id: string;
    readonly nearestAncestors: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly subType: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly subType: string | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type useSmartFolderAncestorSyncQuery = {
  response: useSmartFolderAncestorSyncQuery$data;
  variables: useSmartFolderAncestorSyncQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "type"
},
v3 = {
  "kind": "ScalarField",
  "name": "subType"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": [
          "CURRENT",
          "DRAFT"
        ]
      }
    ],
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "ptpage",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "nearestAncestors",
        "plural": false,
        "selections": [
          {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSmartFolderAncestorSyncQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSmartFolderAncestorSyncQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "701de8d25c0615cd65d074a2d0d26386",
    "id": "9e4874aa6f1795a40140739a4ef2d22670502e0aa0add7ff9834458df2767c17",
    "metadata": {},
    "name": "useSmartFolderAncestorSyncQuery",
    "operationKind": "query",
    "text": "query useSmartFolderAncestorSyncQuery($contentId:ID!){ptpage(id:$contentId,status:[CURRENT,DRAFT]){id,type,subType,nearestAncestors{nodes{id,type,subType}}}}"
  }
};
})();

(node as any).hash = "3feebc26cc696b75c6544fb3f45823b7";

export default node;
